<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row
      v-if="!loadingData && code && storeOrder.attributes"
      align="center"
      class="mx-auto"
    >
      <v-col cols="11" class="mx-auto px-0">
        <v-row>
          <v-col
            cols="12"
            lg="12"
            sm="12"
            class="justify-end align-center d-flex"
          >
            <v-btn
              ref="download"
              data-testid="download-pdf-button"
              elevation="0"
              class="rounded-xxl text-none"
              @click="downloadData()"
              :loading="downloadingPDF"
            >
              <v-icon class="pl-1"> mdi-tray-arrow-down </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" sm="12">
            <p class="text-body-1">
              <span class="mr-2">{{ $t("orderOverviewTitle") }}</span>
              <v-chip
                v-if="storeOrderStatus == true"
                color="success"
                data-testid="chip-order-approved"
                class="rounded-xxl text-none px-4 white--text mr-2"
                >{{ $t("approved") }}</v-chip
              >
              <v-chip
                v-else-if="storeOrderStatus == false"
                color="error"
                data-testid="chip-order-denied"
                class="rounded-xxl text-none px-4 white--text mr-2"
                >{{ $t("denied") }}</v-chip
              >
            </p>
            <v-card
              rounded="xxl"
              class="elevation-2 pa-5"
              data-testid="order-overview-card"
            >
              <p class="text-h6" data-testid="order-product-title">
                {{ storeOrder.attributes.product.title }} {{ (storeOrder.attributes.session) ? ' - ' + storeOrder.attributes.session.session_title : '' }}
              </p>
              <div class="my-4">
                <span class="text-body-2 grey--text">{{
                  $t("orderOrderedBy")
                }}</span>
                <v-row no-gutters>
                  <v-col cols="12" md="6" class="pr-2">
                    <span class="text-body-1" data-testid="order-customer-name"
                      >{{ storeOrder.attributes.first_name }}
                      {{ storeOrder.attributes.last_name }}</span
                    >
                  </v-col>
                  <v-col cols="12" md="6">
                    <span
                      class="text-body-1"
                      data-testid="order-customer-email"
                      >{{ storeOrder.attributes.email }}</span
                    >
                  </v-col>
                </v-row>
              </div>
              <v-divider></v-divider>
              <div class="my-4">
                <span class="text-body-2 grey--text">{{
                  $t("orderNumberOfParticipants")
                }}</span>
                <v-row no-gutters>
                  <v-col cols="12" md="6">
                    <span
                      class="text-body-1"
                      data-testid="order-number-of-participants"
                      >{{ storeOrder.attributes.participants.length }}</span
                    >
                  </v-col>
                </v-row>
              </div>
              <v-divider></v-divider>
              <div class="my-4">
                 <v-row no-gutters>
                    <v-col cols="12" md="6" class="pr-2">
                          <span class="text-body-2 grey--text d-flex">{{ $t('orderInvoiceReference')}}</span>
                        <span class="text-body-1" data-testid="order-company-name">{{ storeOrder.attributes.company_name }}</span>
                    </v-col>
                    <v-col cols="12" md="6" class="">
                        <span class="text-body-2 grey--text d-flex">{{ $t('labelOrderNumber')}}</span>
                        <span class="text-body-1" data-testid="order-number">{{ storeOrder.attributes.number }}</span>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      class="text-body-1"
                      data-testid="order-company-address"
                      >{{ storeOrder.attributes.company_address }}
                      {{ storeOrder.attributes.city }}
                      {{ storeOrder.attributes.post_code }}</span
                    >
                  </v-col>

                  <template v-if="storeOrder.attributes.company_custom_attributes">
                      <v-col cols="12" :key="key" data-testid="order-company-fields" v-for="(value, key) in storeOrder.attributes.company_custom_attributes">
                          <span class="text-body-1" ><strong>{{ key }}:</strong> {{ value }} </span>
                      </v-col>
                  </template>
                </v-row>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" sm="12" data-testid="participants">
            <p class="mt-1 mb-5">{{ $t("orderParticipantsTitle") }}</p>
            <v-card
              rounded="xxl"
              class="elevation-2 pa-5"
              v-if="
                storeOrderStatus == true &&
                storeOrder.attributes.product.productable_type ==
                  'App\\Models\\Hub'
              "
            >
              <v-row
                v-for="participant in storeOrder.attributes.participants"
                :key="participant.id"
                no-gutters
                class="mb-1"
                data-testid="order-participant"
              >
                <v-col cols="12" md="4" class="pr-2">
                  <p class="text-body-1 mb-0 mt-1" @click="openParticipant(participant)">
                    {{ participant.first_name }} {{ participant.last_name }}
                  </p>
                </v-col>
                <v-col cols="12" md="5">
                  <p class="text-body-1 grey--text mb-0 mt-1">
                    {{ participant.email }}
                  </p>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  class="text-right d-md-flex align-md-center justify-md-end pr-5"
                  data-testid="hub-status-participant"
                >
                  <v-chip class="chip" color="accent" text-color="white">
                    {{ $t("hub") }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-card>
            <v-card
              rounded="xxl"
              class="elevation-2 pa-5"
              v-else-if="storeOrderStatus == true"
            >
              <v-row
                v-for="participant in storeOrder.attributes.participants"
                :key="participant.id"
                no-gutters
                class="mb-1"
                data-testid="order-participant"
              >
                <v-col cols="12" md="4" class="pr-2">
                  <p class="text-body-1 mb-0 mt-1" @click="openParticipant(participant)">
                    {{ participant.first_name }} {{ participant.last_name }}
                  </p>
                </v-col>
                <v-col cols="12" md="5">
                  <p class="text-body-1 grey--text mb-0 mt-1">
                    {{ participant.email }}
                  </p>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  class="text-right d-md-flex align-md-center justify-md-end pr-5"
                  data-testid="status-participant"
                >
                  <v-tooltip
                    v-if="getStatusCertificate(participant.user_id)"
                    bottom
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        data-testid="certificate-icon-download-button"
                        class="chip"
                        :color="getStatusColor(participant.user_id)"
                        text-color="white"
                        @click="downloadCertificate(participant)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ getStatus(participant.user_id) }}
                        <v-icon
                          class="ml-2"
                          data-testid="certificate-icon"
                        >
                          mdi-certificate-outline
                        </v-icon>
                      </v-chip>
                    </template>
                    <span>{{ $t('certificateInActivityAvailableTooltip') }}</span>
                  </v-tooltip>  
                  <v-chip
                    v-else
                    data-testid="certificate-icon-download-button-missing"
                    class="chip"
                    :color="getStatusColor(participant.user_id)"
                    text-color="white"
                  >
                    {{ getStatus(participant.user_id) }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-else class="fill-height" align="center">
      <v-col
        align="center"
        cols="12"
        sm="8"
        md="6"
        lg="4"
        offset-sm="2"
        offset-md="3"
        offset-lg="4"
      >
        <v-img
          :src="require('../../assets/image3.png')"
          width="100%"
          max-width="400px"
          class="mx-auto mb-10"
          @load="loadingImage = false"
        />
        <p class="text-h5 font-weight-bold" data-testid="access-code-title">
          {{ $t("enterAccessCode") }}
        </p>

        <v-form 
          ref="form"
          @submit.prevent
          @keyup.enter="fetchStoreOrder()"
        >
          <v-row>
            <v-col cols="12" sm="12" md="12" offset-sm="0" offset-md="0">
              <v-text-field
                v-model="code"
                maxlength="5"
                solo
                class="rounded-xxl text-body-2"
                ref="accessCodeField"
                data-testid="access-code-field"
                @keyup.enter="fetchStoreOrder()"
                :placeholder="$t('accessCodePlaceholder')"
              />
            </v-col>
          </v-row>

          <v-btn
            ref="cancel"
            data-testid="cancel-button"
            outlined
            elevation="0"
            class="rounded-xxl text-none mr-8 px-4 mt-2"
            @click="$router.go(-1)"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            data-testid="confirm-button"
            :loading="loadingData"
            color="error"
            class="rounded-xxl text-none px-4 mt-2"
            :disabled="!code"
            @click="fetchStoreOrder()"
          >
            {{ $t("confirmBtn") }}
          </v-btn>
        </v-form>
      </v-col>
    </v-row>

    <ParticipantDetails
      v-if="showParticipant"
      ref="showParticipantDialog"
      :visible="showParticipant"
      :participant="selectedParticipant"
      :custom_attributes="storeOrder.attributes.product.participant_custom_attributes"
      :participant_attributes="processedParticipantAttributes"
      data-testid="view-dialog-participant" 
      @close="showParticipant=false"
    /> 
  </nav>
</template>
<script>
import { repeatedMethodsMixin } from "../../mixins/repeatedMethodsMixin";
import {
  getStoreOrderPublic,
  getStoreOrderUsersStatisticsPublic,
  downloadOrderDataPublic,
} from "../../api/productApi";
import AlertMessages from "../../components/AlertMessages";
import ParticipantDetails from '../../components/ParticipantDetails'
import i18n from "../../plugins/i18n";
import jsPDF from "jspdf"

export default {
  components: {
    AlertMessages,
    ParticipantDetails
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      alertType: "",
      alertMsg: "",
      alertValue: false,
      spaceId: window.$cookies.get("space_id"),
      loadingData: false,
      storeOrder: {},
      code: "",
      storeID: this.$route.params.id,
      dialogVisibleApproveDenyOrder: false,
      approved: null,
      storeOrderUsersStatistics: [],
      storeOrderCertificateData: [],
      downloadingPDF: false,
      showParticipant: false,
    };
  },
  mounted() {
    this.$refs.accessCodeField.focus();
  },
  computed: {
    processedParticipantAttributes() {
      if (
          Array.isArray(this.storeOrder.attributes.product.additional_attributes_for_participants) && 
          this.storeOrder.attributes.product.additional_attributes_for_participants.length === 0) {
          return {};
      } else {
          return this.storeOrder.attributes.product.additional_attributes_for_participants;
      }
    }
  },
  async created() {
    i18n.locale = window.$cookies.get('language') ? window.$cookies.get('language') : window.$cookies.get('space_language') ? window.$cookies.get('space_language') : 'sv';
  },
  methods: {
    openParticipant(participant) {
        this.showParticipant = true;
        this.selectedParticipant = participant;
    },
    async downloadData() {
      this.downloadingPDF = true;
      try {
        let data = {
          data: {
            type: "store-orders",
            attributes: {
              code: this.code,
            },
          },
        };
        const response = await downloadOrderDataPublic(this.storeID, data);
        if (response.status) {
          if (response.status == 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Order-statistics.pdf");
            document.body.appendChild(link);
            link.click();
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
      this.downloadingPDF = false;
    },
    async fetchStoreOrder() {
      this.loadingData = true;
      try {
        let data = {
          data: {
            type: "store-orders",
            attributes: {
              code: this.code,
            },
          },
        };
        const response = await getStoreOrderPublic(this.storeID, data);
        if (response.status == 200) {
          this.storeOrder = response.data.data;
          this.storeOrderStatus = response.data.data.attributes.approved;
          if (
            this.storeOrderStatus == true &&
            this.storeOrder.attributes.product.productable_type !=
              "App\\Models\\Hub"
          ) {
            await this.fetchStoreOrderUsersStatistics();
          }
        }
        this.loadingData = false;
      } catch (e) {
        if (e.response) {
          if (e.response.status == 400) {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("unauthorizedAccess");
          } else if (e.response.status == 404) {
            this.$router.push({ name: "PageNotFound" });
          } else if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
        this.loadingData = false;
      }
    },

    async fetchStoreOrderUsersStatistics() {
      try {
        let data = {
          data: {
            type: "store-orders",
            attributes: {
              code: this.code,
            },
          },
        };
        const response = await getStoreOrderUsersStatisticsPublic(
          this.storeID,
          data
        );
        if (response.status == 200) {
          this.storeOrderUsersStatistics = response.data.meta.statistics ? response.data.meta.statistics : [];
          this.storeOrderCertificateData = response.data.meta.activity_certificate_data ? response.data.meta.activity_certificate_data : [];
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: "PageNotFound" });
          } else if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },

    getStatusColor(participantId) {
      const participantStatus = this.storeOrderUsersStatistics.find(
        (stat) => stat.user_id === participantId
      );
      if (participantStatus) {
        if (!participantStatus.completed) {
          return "bluelight"; //notstarted
        } else if (participantStatus.completed == participantStatus.total) {
          return "green"; //  finished
        } else {
          return "warning"; //started
        }
      }
      return "graylight";
    },
    getStatus(participantId) {
      const participantStatus = this.storeOrderUsersStatistics.find(
        (stat) => stat.user_id === participantId
      );
      if (participantStatus) {
        if (!participantStatus.completed) {
          return i18n.t("notStarted");
        } else if (participantStatus.completed == participantStatus.total) {
          return i18n.t("finished");
        } else {
          return i18n.t("started");
        }
      }
      return "N/A";
    },
    getStatusCertificate(participantId) {
      const participantStatus = this.storeOrderUsersStatistics.find(
        (stat) => stat.user_id === participantId
      );
      if (participantStatus) {
        if (participantStatus.certificate) {
          return true
        }
      }
      return false
    },
    async downloadCertificate(participant){
      const participantId = participant.user_id
      const participantStatus = this.storeOrderUsersStatistics.find(
        (stat) => stat.user_id === participantId
      );

      if (participantStatus && participantStatus.certificate) {
        var newLogo = this.storeOrderCertificateData.space_logo
        var newSubdomain = this.storeOrderCertificateData.space_subdomain
        var logo = newLogo ? logo = newLogo + '?notfromcache' : logo = require('../../assets/rtplogo.svg')
        let name = participant ? participant.first_name + ' ' + participant.last_name : 'null'
        let domain = newSubdomain ? newSubdomain + '.' + process.env.VUE_APP_DOMAIN : process.env.VUE_APP_DOMAIN
        if (name && name != ' ' && logo && this.storeOrderCertificateData.title) {
          var RobotoFont = require('../../components/RobotoFont')
          var robotoFont = new RobotoFont.RobotoFont()
          var font = robotoFont.getFont()
          var callAddFont = function () {
          this.addFileToVFS('Roboto-Regular-normal.ttf', font);
          this.addFont('Roboto-Regular-normal.ttf', 'Roboto-Regular', 'normal');
          };
          jsPDF.API.events.push(['addFonts', callAddFont])

          var doc = new jsPDF()
          let pdfName = 'Certificate_' + this.storeOrderCertificateData.title + '_' + name

          var width = doc.internal.pageSize.getWidth()
          let pageHeight = doc.internal.pageSize.getHeight()
          
          let certificateTextPart1 = i18n.t('certificateTextPart1');
          let certificateTextPart2 = i18n.t('certificateTextPart2');
          let certificateTextPart3 = i18n.t('certificateTextPart3');
          let certificateTextDate = i18n.t('certificateTextDate');

          doc.setFont('Roboto-Regular', 'normal');
          doc.setTextColor(0, 0, 0, 0.80)
          doc.setFontSize(16)
          doc.text(certificateTextPart1, width/2, 80, { align: 'center', maxWidth: width-30 })
          doc.setFontSize(22)
          doc.text(name, width/2, 100, { align: 'center', maxWidth: width-30 })
          doc.setFontSize(16)
          doc.text(certificateTextPart2, width/2, 120, { align: 'center', maxWidth: width-30 })
          doc.setFontSize(22)
          doc.text(this.storeOrderCertificateData.title, width/2, 140, { align: 'center', maxWidth: width-30 })
          doc.setFontSize(16)
          doc.text(certificateTextPart3, width/2, 170, { align: 'center', maxWidth: width-30 })
          doc.text(certificateTextDate + ': ' + participantStatus.certificate.created_at.slice(0, 10), width/2, 230, { align: 'center', maxWidth: width-30 })
          doc.text(domain, width/2, pageHeight-20, { align: 'center', maxWidth: width-30 })

          if (logo.split(/[#?]/)[0].split('.').pop().trim() == 'svg') {
            var XMLrequest = new XMLHttpRequest() // new XML request
            XMLrequest.crossOrigin = "anonymous"
            XMLrequest.open("GET", logo, false) // URL of the SVG file on server
            XMLrequest.send(null) // get the SVG file

            var mySVG = XMLrequest.responseXML.getElementsByTagName("svg")[0]

            var svgString = new XMLSerializer().serializeToString(mySVG)

            var data = "data:image/svg+xml;utf8," + encodeURIComponent(svgString);

            var canvas = document.createElement('canvas')
            var svgwidth = mySVG.width.baseVal.value
            var svgheight = mySVG.height.baseVal.value
            canvas.width = svgwidth
            canvas.height = svgheight

            var ctx = canvas.getContext("2d")
            ctx.clearRect(0, 0, canvas.width, canvas.height)
            
            var img = new Image()
            img.src = data
        
            img.onload = function() {
                let devide = this.height/28
                let imageWidth = this.width/devide
                ctx.drawImage(img, 0, 0)
                var png = canvas.toDataURL("image/png")
                doc.addImage(png, width/2-imageWidth/2, 20, imageWidth, 28)
                doc.save(pdfName + '.pdf')
            }
          } else if (logo.split(/[#?]/)[0].split('.').pop().trim() == 'jpg' ||
            logo.split(/[#?]/)[0].split('.').pop().trim() == 'jpeg' || 
            logo.split(/[#?]/)[0].split('.').pop().trim() == 'png') {
              let img = new Image
              img.src = logo
              img.crossOrigin = "anonymous"

              img.onload = function() {
                let devide = this.height/28
                let imageWidth = this.width/devide
                doc.addImage(this, width/2-imageWidth/2, 20, imageWidth, 28)
                doc.save(pdfName + '.pdf')
              }                           
          }
        }
      }
    } 
  }
};
</script>
